/* Lenis smooth-scroll + GSAP ScrollTrigger bridge.
   Single source of truth for scroll timing across the site. */

import Lenis from 'lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initSmoothScroll() {
  const lenis = new Lenis({
    duration: 1.1,
    easing:  (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smoothWheel: true,
  });

  // Drive Lenis from the RAF loop; forward scroll events into ScrollTrigger.
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  lenis.on('scroll', ScrollTrigger.update);
  gsap.ticker.add((time) => lenis.raf(time * 1000));
  gsap.ticker.lagSmoothing(0);

  // Expose for external callers (e.g. nav links that need to jump).
  window.__lenis = lenis;
  return lenis;
}
